var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "abherov2" },
    [
      _vm.state === "collecting"
        ? [
            _c(
              "div",
              {
                staticClass: "abherov2__source",
                class: { "abherov2__source--disabled": _vm.disabled },
              },
              [
                _c("div", { staticClass: "abherov2__srcthumb" }, [
                  _vm.sourceImage && !_vm.sourceThumbError
                    ? _c("img", {
                        staticClass: "abherov2__srcimg",
                        attrs: {
                          src: _vm.sourceImage,
                          "data-fullsrc": _vm.sourceFull,
                          alt: "Source",
                        },
                        on: {
                          error: function ($event) {
                            _vm.sourceThumbError = true
                          },
                        },
                      })
                    : _vm.sourceResolving
                    ? _c("i", {
                        staticClass: "bi bi-arrow-repeat abherov2__srcspin",
                        attrs: { title: "Fetching the product image…" },
                      })
                    : _c("i", {
                        staticClass: "bi bi-image abherov2__srcthumb-fallback",
                        attrs: { title: "Source product image" },
                      }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "abherov2__srcbody" }, [
                  _c("div", { staticClass: "abherov2__label" }, [
                    _vm._v("\n          Source\n        "),
                  ]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.sourceRow.text,
                        expression: "sourceRow.text",
                      },
                    ],
                    staticClass: "abherov2__text",
                    attrs: {
                      rows: "1",
                      placeholder: "ASIN, paste, upload, or drop an image",
                      disabled: _vm.disabled,
                    },
                    domProps: { value: _vm.sourceRow.text },
                    on: {
                      paste: function ($event) {
                        return _vm.onPaste(_vm.sourceIdx, $event)
                      },
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.sourceRow, "text", $event.target.value)
                        },
                        function ($event) {
                          return _vm.onSourceText($event)
                        },
                      ],
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        $event.preventDefault()
                        return $event.target.blur()
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "abherov2__icons" }, [
                  _vm.hasText(_vm.sourceRow) || _vm.sourceRow.image
                    ? _c(
                        "button",
                        {
                          staticClass: "abherov2__clear",
                          attrs: {
                            type: "button",
                            disabled: _vm.disabled,
                            title: "Clear",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.clearContent(_vm.sourceIdx)
                            },
                          },
                        },
                        [_vm._v("\n          ×\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "abherov2__icon",
                      attrs: {
                        type: "button",
                        disabled: _vm.disabled,
                        title: "Upload from device",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.pick(_vm.sourceIdx, "upload")
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "abherov2__icon-svg",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "15",
                            height: "15",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "aria-hidden": "true",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "abherov2__icon",
                      attrs: {
                        type: "button",
                        disabled: _vm.disabled,
                        title: "Pick from file browser or Salsify",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.pick(_vm.sourceIdx, "browser")
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "abherov2__icon-svg",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "15",
                            height: "15",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "aria-hidden": "true",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "abherov2__icon",
                      attrs: {
                        type: "button",
                        disabled: _vm.disabled,
                        title: "Save or reuse a prompt",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.promptClipboard(_vm.sourceIdx)
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "abherov2__icon-svg",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "15",
                            height: "15",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "aria-hidden": "true",
                          },
                        },
                        [
                          _c("rect", {
                            attrs: {
                              width: "8",
                              height: "4",
                              x: "8",
                              y: "2",
                              rx: "1",
                              ry: "1",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "abherov2__canvases" }, [
              _vm.variantARow.mode === "original"
                ? _c(
                    "button",
                    {
                      staticClass: "abherov2__pill",
                      attrs: {
                        type: "button",
                        disabled: _vm.disabled,
                        title: "Modify Variant A instead of using source as-is",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.setVariantMode("variantA", "text")
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "abherov2__label" }, [
                        _vm._v("Variant A"),
                      ]),
                      _vm._v(" "),
                      _vm.sourceImage
                        ? _c("img", {
                            staticClass: "abherov2__pillimg",
                            attrs: { src: _vm.sourceImage, alt: "" },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "abherov2__pilltext" }, [
                        _vm._v("\n          Same as source\n        "),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "abherov2__pillhint" }, [
                        _vm._v("\n          Click to modify →\n        "),
                      ]),
                    ]
                  )
                : _c("div", { staticClass: "abherov2__canvas" }, [
                    _c("div", { staticClass: "abherov2__canvashead" }, [
                      _c("span", { staticClass: "abherov2__label" }, [
                        _vm._v("Variant A"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "abherov2__useorig",
                          attrs: { type: "button", disabled: _vm.disabled },
                          on: {
                            click: function ($event) {
                              return _vm.setVariantMode("variantA", "original")
                            },
                          },
                        },
                        [_vm._v("\n            Use source as-is\n          ")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "abherov2__canvasbody" }, [
                      _vm.variantARow.image &&
                      _vm.thumbSrc(_vm.variantARow) &&
                      !_vm.thumbErrors[_vm.variantARow.key]
                        ? _c("img", {
                            staticClass: "abherov2__thumb",
                            attrs: {
                              src: _vm.thumbSrc(_vm.variantARow),
                              "data-fullsrc": _vm.fullSrc(_vm.variantARow),
                              alt: "",
                            },
                            on: {
                              error: function ($event) {
                                return _vm.$set(
                                  _vm.thumbErrors,
                                  _vm.variantARow.key,
                                  true
                                )
                              },
                            },
                          })
                        : _vm.variantARow.image &&
                          _vm.thumbErrors[_vm.variantARow.key]
                        ? _c("i", {
                            staticClass:
                              "bi bi-image abherov2__thumb abherov2__thumb--fallback",
                            attrs: {
                              title: "Selected image (preview unavailable)",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.variantARow.text,
                            expression: "variantARow.text",
                          },
                        ],
                        staticClass: "abherov2__text",
                        attrs: {
                          rows: "1",
                          placeholder:
                            "ASIN, paste image, or describe the variation…",
                          disabled: _vm.disabled,
                        },
                        domProps: { value: _vm.variantARow.text },
                        on: {
                          paste: function ($event) {
                            return _vm.onPaste(_vm.variantAIdx, $event)
                          },
                          input: [
                            function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.variantARow,
                                "text",
                                $event.target.value
                              )
                            },
                            function ($event) {
                              return _vm.onText($event)
                            },
                          ],
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "abherov2__icons" }, [
                        _vm.hasText(_vm.variantARow) || _vm.variantARow.image
                          ? _c(
                              "button",
                              {
                                staticClass: "abherov2__clear",
                                attrs: {
                                  type: "button",
                                  disabled: _vm.disabled,
                                  title: "Clear",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.clearContent(_vm.variantAIdx)
                                  },
                                },
                              },
                              [_vm._v("\n              ×\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "abherov2__icon",
                            attrs: {
                              type: "button",
                              disabled: _vm.disabled,
                              title: "Upload from device",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.pick(_vm.variantAIdx, "upload")
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "abherov2__icon-svg",
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "15",
                                  height: "15",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "aria-hidden": "true",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "abherov2__icon",
                            attrs: {
                              type: "button",
                              disabled: _vm.disabled,
                              title: "Pick from file browser or Salsify",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.pick(_vm.variantAIdx, "browser")
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "abherov2__icon-svg",
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "15",
                                  height: "15",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "aria-hidden": "true",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "abherov2__icon",
                            attrs: {
                              type: "button",
                              disabled: _vm.disabled,
                              title: "Save or reuse a prompt",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.promptClipboard(_vm.variantAIdx)
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "abherov2__icon-svg",
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "15",
                                  height: "15",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "aria-hidden": "true",
                                },
                              },
                              [
                                _c("rect", {
                                  attrs: {
                                    width: "8",
                                    height: "4",
                                    x: "8",
                                    y: "2",
                                    rx: "1",
                                    ry: "1",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    !_vm.disabled &&
                    !_vm.hasText(_vm.variantARow) &&
                    _vm.samplesFor(_vm.variantARow).length
                      ? _c(
                          "div",
                          { staticClass: "abherov2__samplewrap" },
                          _vm._l(
                            _vm.samplesFor(_vm.variantARow),
                            function (ex, exIdx) {
                              return _c(
                                "button",
                                {
                                  key: exIdx,
                                  staticClass: "abherov2__sample",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.disabled,
                                    title: ex.text,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.applyChip(
                                        _vm.variantAIdx,
                                        ex.text
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(ex.label) +
                                      "\n          "
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                  ]),
              _vm._v(" "),
              _c("div", { staticClass: "abherov2__canvas" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "abherov2__canvasbody" }, [
                  _vm.variantBRow.image &&
                  _vm.thumbSrc(_vm.variantBRow) &&
                  !_vm.thumbErrors[_vm.variantBRow.key]
                    ? _c("img", {
                        staticClass: "abherov2__thumb",
                        attrs: {
                          src: _vm.thumbSrc(_vm.variantBRow),
                          "data-fullsrc": _vm.fullSrc(_vm.variantBRow),
                          alt: "",
                        },
                        on: {
                          error: function ($event) {
                            return _vm.$set(
                              _vm.thumbErrors,
                              _vm.variantBRow.key,
                              true
                            )
                          },
                        },
                      })
                    : _vm.variantBRow.image &&
                      _vm.thumbErrors[_vm.variantBRow.key]
                    ? _c("i", {
                        staticClass:
                          "bi bi-image abherov2__thumb abherov2__thumb--fallback",
                        attrs: {
                          title: "Selected image (preview unavailable)",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.variantBRow.text,
                        expression: "variantBRow.text",
                      },
                    ],
                    staticClass: "abherov2__text",
                    attrs: {
                      rows: "1",
                      placeholder:
                        "ASIN, paste image, or describe the variation…",
                      disabled: _vm.disabled,
                    },
                    domProps: { value: _vm.variantBRow.text },
                    on: {
                      paste: function ($event) {
                        return _vm.onPaste(_vm.variantBIdx, $event)
                      },
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.variantBRow, "text", $event.target.value)
                        },
                        function ($event) {
                          return _vm.onText($event)
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "abherov2__icons" }, [
                    _vm.hasText(_vm.variantBRow) || _vm.variantBRow.image
                      ? _c(
                          "button",
                          {
                            staticClass: "abherov2__clear",
                            attrs: {
                              type: "button",
                              disabled: _vm.disabled,
                              title: "Clear",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.clearContent(_vm.variantBIdx)
                              },
                            },
                          },
                          [_vm._v("\n              ×\n            ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "abherov2__icon",
                        attrs: {
                          type: "button",
                          disabled: _vm.disabled,
                          title: "Upload from device",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.pick(_vm.variantBIdx, "upload")
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "abherov2__icon-svg",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "15",
                              height: "15",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "aria-hidden": "true",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "abherov2__icon",
                        attrs: {
                          type: "button",
                          disabled: _vm.disabled,
                          title: "Pick from file browser or Salsify",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.pick(_vm.variantBIdx, "browser")
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "abherov2__icon-svg",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "15",
                              height: "15",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "aria-hidden": "true",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "abherov2__icon",
                        attrs: {
                          type: "button",
                          disabled: _vm.disabled,
                          title: "Save or reuse a prompt",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.promptClipboard(_vm.variantBIdx)
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "abherov2__icon-svg",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "15",
                              height: "15",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "aria-hidden": "true",
                            },
                          },
                          [
                            _c("rect", {
                              attrs: {
                                width: "8",
                                height: "4",
                                x: "8",
                                y: "2",
                                rx: "1",
                                ry: "1",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                !_vm.disabled &&
                !_vm.hasText(_vm.variantBRow) &&
                _vm.samplesFor(_vm.variantBRow).length
                  ? _c(
                      "div",
                      { staticClass: "abherov2__samplewrap" },
                      _vm._l(
                        _vm.samplesFor(_vm.variantBRow),
                        function (ex, exIdx) {
                          return _c(
                            "button",
                            {
                              key: exIdx,
                              staticClass: "abherov2__sample",
                              attrs: {
                                type: "button",
                                disabled: _vm.disabled,
                                title: ex.text,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.applyChip(_vm.variantBIdx, ex.text)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(ex.label) +
                                  "\n          "
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "abherov2__footer" }, [
              _c("label", { staticClass: "abherov2__size" }, [
                _c("span", { staticClass: "abherov2__size-label" }, [
                  _vm._v("Image size"),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.localSize,
                        expression: "localSize",
                      },
                    ],
                    staticClass: "abherov2__size-select",
                    attrs: {
                      disabled: _vm.disabled,
                      title: "Output size — PDP images are square (1:1)",
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.localSize = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.emitFormState,
                      ],
                    },
                  },
                  _vm._l(_vm.sizeOptions, function (opt) {
                    return _c(
                      "option",
                      { key: opt, domProps: { value: opt } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(opt.replace("x", " × ")) +
                            "\n          "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "abherov2__generate",
                  attrs: {
                    type: "button",
                    disabled: !_vm.canGenerate || _vm.disabled,
                  },
                  on: { click: _vm.generate },
                },
                [
                  !_vm.generating
                    ? _c("span", [
                        _vm._v("Generate "),
                        _c("i", { staticClass: "bi bi-arrow-right" }),
                      ])
                    : _c("span", [
                        _vm._v("Generating "),
                        _c("span", { staticClass: "abherov2__dots" }, [
                          _vm._v("···"),
                        ]),
                      ]),
                ]
              ),
            ]),
          ]
        : [
            _c(
              "div",
              { staticClass: "abherov2__cards" },
              _vm._l(_vm.tiles, function (tile) {
                return _c(
                  "div",
                  { key: tile.rowIndex, staticClass: "abherov2__card" },
                  [
                    _c("div", { staticClass: "abherov2__variant" }, [
                      _vm._v(
                        "\n          " + _vm._s(tile.label) + "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "abherov2__stage",
                        on: {
                          mouseenter: function ($event) {
                            _vm.hovered = tile.rowIndex
                          },
                          mouseleave: function ($event) {
                            _vm.hovered = null
                          },
                        },
                      },
                      [
                        (tile.state === "generating" && tile.url) ||
                        (tile.state === "done" && tile.saving && tile.url)
                          ? [
                              _c("img", {
                                staticClass:
                                  "abherov2__resultimg abherov2__resultimg--regen",
                                class: {
                                  "abherov2__resultimg--contain":
                                    tile.mode === "original",
                                },
                                attrs: { src: tile.url, alt: tile.label },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "abherov2__regen" }, [
                                _c(
                                  "span",
                                  { staticClass: "abherov2__regen-pill" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        tile.saving ? "Saving" : "Regenerating"
                                      ) + " "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "abherov2__dots" },
                                      [_vm._v("···")]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          : tile.state === "done" && tile.url
                          ? [
                              _c("img", {
                                staticClass: "abherov2__resultimg",
                                class: {
                                  "abherov2__resultimg--contain":
                                    tile.mode === "original",
                                },
                                attrs: { src: tile.url, alt: tile.label },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hovered === tile.rowIndex,
                                      expression: "hovered === tile.rowIndex",
                                    },
                                  ],
                                  staticClass: "abherov2__imgactions",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "abherov2__iconbtn",
                                      attrs: {
                                        type: "button",
                                        title: "Download",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.download(tile.rowIndex)
                                        },
                                      },
                                    },
                                    [_c("i", { staticClass: "bi bi-download" })]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "abherov2__iconbtn",
                                      attrs: {
                                        type: "button",
                                        title: "Save to File Browser",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.save(tile.rowIndex)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "bi bi-folder-plus",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          : tile.state === "error"
                          ? _c(
                              "div",
                              { staticClass: "abherov2__resulterror" },
                              [
                                _c("i", {
                                  staticClass:
                                    "bi bi-exclamation-triangle abherov2__resulterror-icon",
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "abherov2__resulterror-text" },
                                  [_vm._v("Couldn't generate")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "abherov2__resultretry",
                                    attrs: {
                                      type: "button",
                                      disabled: _vm.anyGenerating,
                                      title: _vm.anyGenerating
                                        ? "Wait for the other variant to finish generating"
                                        : "Retry",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.regen(tile.rowIndex)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "bi bi-arrow-clockwise",
                                    }),
                                    _vm._v(" Retry\n            "),
                                  ]
                                ),
                              ]
                            )
                          : _c(
                              "div",
                              { staticClass: "abherov2__resultplaceholder" },
                              [
                                _c("i", {
                                  staticClass:
                                    "bi bi-stars abherov2__resultspark",
                                }),
                                _vm._v(" "),
                                tile.slow
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "abherov2__resultretry abherov2__resultretry--slow",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.regen(tile.rowIndex)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "bi bi-arrow-clockwise",
                                        }),
                                        _vm._v(
                                          " Taking a while — Retry\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.showPromptEditor(tile)
                      ? [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.editPrompt[tile.rowIndex],
                                expression: "editPrompt[tile.rowIndex]",
                              },
                            ],
                            ref: `editTa-${tile.rowIndex}`,
                            refInFor: true,
                            staticClass: "abherov2__captionedit",
                            attrs: {
                              placeholder:
                                "Describe what to change, then click Regenerate…",
                              disabled: tile.state !== "done",
                            },
                            domProps: { value: _vm.editPrompt[tile.rowIndex] },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.editPrompt,
                                  tile.rowIndex,
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "abherov2__cardfoot" }, [
                            _vm.versions(tile).length > 1
                              ? _c(
                                  "div",
                                  { staticClass: "abherov2__history" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "abherov2__history-label",
                                      },
                                      [_vm._v("Previous")]
                                    ),
                                    _vm._v(" "),
                                    _vm.historyPaged(tile)
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "abherov2__historynav",
                                            attrs: {
                                              type: "button",
                                              disabled:
                                                tile.state !== "done" ||
                                                !_vm.canHistoryPrev(tile),
                                              title: "Newer versions",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.pageHistory(
                                                  tile.rowIndex,
                                                  -1
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "bi bi-chevron-left",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "abherov2__history-strip",
                                      },
                                      _vm._l(
                                        _vm.historyWindow(tile),
                                        function (h) {
                                          return _c(
                                            "button",
                                            {
                                              key: h,
                                              staticClass:
                                                "abherov2__historythumb",
                                              class: {
                                                "abherov2__historythumb--active":
                                                  h === tile.url,
                                              },
                                              attrs: {
                                                type: "button",
                                                disabled: tile.state !== "done",
                                                title:
                                                  h === tile.url
                                                    ? "Current version"
                                                    : "Use this version",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.select(
                                                    tile.rowIndex,
                                                    h
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: _vm.historyThumb(h),
                                                  alt: "",
                                                },
                                              }),
                                              _vm._v(" "),
                                              h === tile.url
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "abherov2__historycheck",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "bi bi-check-lg",
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                    _vm._v(" "),
                                    _vm.historyPaged(tile)
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "abherov2__historynav",
                                            attrs: {
                                              type: "button",
                                              disabled:
                                                tile.state !== "done" ||
                                                !_vm.canHistoryNext(tile),
                                              title: "Older versions",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.pageHistory(
                                                  tile.rowIndex,
                                                  1
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "bi bi-chevron-right",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "abherov2__regenrow" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "abherov2__sparkbtn",
                                  attrs: {
                                    type: "button",
                                    disabled: tile.state !== "done",
                                    title: "Save or reuse a prompt",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openPromptClipboard(tile)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "abherov2__icon-svg",
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "aria-hidden": "true",
                                      },
                                    },
                                    [
                                      _c("rect", {
                                        attrs: {
                                          width: "8",
                                          height: "4",
                                          x: "8",
                                          y: "2",
                                          rx: "1",
                                          ry: "1",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "abherov2__regenbtn",
                                  attrs: {
                                    type: "button",
                                    disabled:
                                      tile.state !== "done" ||
                                      _vm.anyGenerating,
                                    title:
                                      _vm.anyGenerating && tile.state === "done"
                                        ? "Wait for the other variant to finish generating"
                                        : "Regenerate this variant",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onRegenerate(tile)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "bi bi-arrow-counterclockwise",
                                  }),
                                  _vm._v(" Regenerate\n              "),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "abherov2__resultfooter" }, [
              _c(
                "button",
                {
                  staticClass: "abherov2__createlayout",
                  attrs: {
                    type: "button",
                    disabled: !_vm.canCreateLayout,
                    title:
                      "Create an editable layout from the generated image(s)",
                  },
                  on: { click: _vm.createLayout },
                },
                [
                  _c("i", { staticClass: "bi bi-columns-gap" }),
                  _vm._v(" Create layout\n      "),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "abherov2__optix",
                  attrs: { type: "button", disabled: !_vm.canTest },
                  on: { click: _vm.act },
                },
                [
                  _vm._v("\n        A/B test in Optix™ "),
                  _c("i", { staticClass: "bi bi-arrow-right" }),
                ]
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "abherov2__canvashead" }, [
      _c("span", { staticClass: "abherov2__label" }, [_vm._v("Variant B")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }